import api from '@services/api'

export default {
  list(axios, params, query, config) {
    return api.get(axios, '/organizations', params, query, config)
  },
}
